var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Mock data for boards
const mockBoards = [
    {
        id: 1,
        code: 'BOARD001',
        title: 'Test Board 1',
        state: {},
        createdBy: 1,
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z',
    },
    {
        id: 2,
        code: 'BOARD002',
        title: 'Test Board 2',
        state: {},
        createdBy: 1,
        createdAt: '2024-01-02T00:00:00Z',
        updatedAt: '2024-01-02T00:00:00Z',
    },
];
export const mockBoardApi = {
    getBoardByCode: (boardCode) => __awaiter(void 0, void 0, void 0, function* () {
        const board = mockBoards.find((b) => b.code === boardCode);
        if (!board) {
            throw new Error('Board not found');
        }
        return Promise.resolve(board);
    }),
    list: (createdById) => __awaiter(void 0, void 0, void 0, function* () {
        if (createdById) {
            return Promise.resolve(mockBoards.filter((b) => b.createdBy === createdById));
        }
        return Promise.resolve(mockBoards);
    }),
    create: (boardTitle, code) => __awaiter(void 0, void 0, void 0, function* () {
        const newBoard = {
            id: mockBoards.length + 1,
            code: code || `BOARD${String(mockBoards.length + 1).padStart(3, '0')}`,
            title: boardTitle,
            state: {},
            createdBy: 1,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        };
        mockBoards.push(newBoard);
        return Promise.resolve(newBoard);
    }),
    update: (code, data) => __awaiter(void 0, void 0, void 0, function* () {
        const boardIndex = mockBoards.findIndex((b) => b.code === code);
        if (boardIndex === -1) {
            throw new Error('Board not found');
        }
        mockBoards[boardIndex] = Object.assign(Object.assign({}, mockBoards[boardIndex]), data);
        return Promise.resolve(mockBoards[boardIndex]);
    }),
    delete: (code) => __awaiter(void 0, void 0, void 0, function* () {
        const boardIndex = mockBoards.findIndex((b) => b.code === code);
        if (boardIndex === -1) {
            throw new Error('Board not found');
        }
        mockBoards.splice(boardIndex, 1);
        return Promise.resolve();
    }),
    createSnapshot: (code_1, state_1, ...args_1) => __awaiter(void 0, [code_1, state_1, ...args_1], void 0, function* (code, state, label = '') {
        return Promise.resolve({
            id: 1,
            board: code,
            state,
            label,
            createdAt: new Date().toISOString(),
        });
    }),
    listSnapshots: (code) => __awaiter(void 0, void 0, void 0, function* () {
        return Promise.resolve([
            {
                id: 1,
                board: code,
                state: {},
                label: 'Test snapshot',
                createdAt: new Date().toISOString(),
            },
        ]);
    }),
    restoreSnapshot: (code, snapshotId) => __awaiter(void 0, void 0, void 0, function* () {
        return Promise.resolve({ ok: true });
    }),
    reorderPresentationElements: (code, elements) => __awaiter(void 0, void 0, void 0, function* () {
        return Promise.resolve({ ok: true });
    }),
};
